import { SignalBinding } from "signals";
import Components from "slotworks/components/components";
import AbstractMediator from "slotworks/mediators/abstract-mediator";
import SlotDefinition from "slotworks/model/slot-definition";
import { SoundEvent } from "slotworks/sound/sound-events";
import SoundManager from "slotworks/sound/sound-manager";
import Contract from "slotworks/utils/contract";

export default class LandSoundsMediator extends AbstractMediator {

    private bonusCount: Map<number, number>;

    private signals: SignalBinding[];

    public start(): Contract<void> {
        this.signals = [];

        this.bonusCount = new Map<number, number>();

        for (const symbol of Components.matrix.getAllSymbols()) {
            const landBinding = symbol.landSignal.addOnce(() => {
                const symbolDef = SlotDefinition.getSymbolDefinition(symbol.symbolId);
                const bonusId = symbolDef.bonusId;

                if (bonusId === 0) {
                    return;
                }

                if (!this.bonusCount.has(bonusId)) {
                    this.bonusCount.set(bonusId, 0);
                }

                const currentCount = this.bonusCount.get(bonusId) + 1;

                this.bonusCount.set(bonusId, currentCount);

                let bonusTriggerPossible = false;

                if (currentCount > symbolDef.matchesMin) {
                    bonusTriggerPossible = true;
                } else {
                    const currentReel = symbol.gridPosition.x;
                    let remainingBonusReels = 0;

                    for (let reel = currentReel + 1; reel <= SlotDefinition.matrixGrid.length; reel++) {
                        if (symbolDef.reels && symbolDef.reels.indexOf(reel) >= 0) {
                            remainingBonusReels++;
                        }
                    }

                    if (currentCount + remainingBonusReels >= symbolDef.matchesMin) {
                        bonusTriggerPossible = true;
                    }
                }

                if (bonusTriggerPossible) {
                    SoundManager.event(SoundEvent.bonus_SYMBOL_land, symbolDef.id);
                    SoundManager.event(SoundEvent.bonus_SYMBOL_land_COUNT, symbolDef.id, currentCount.toString());
                    if (symbolDef.bonusId) {
                        SoundManager.event(SoundEvent.bonus_ID_land, symbolDef.bonusId.toString());
                        SoundManager.event(SoundEvent.bonus_ID_land_COUNT, symbolDef.bonusId.toString(), currentCount.toString());
                    }
                }

            });

            this.signals.push(landBinding);
        }

        return super.start();
    }

    public end() {
        for (const binding of this.signals) {
            binding.detach();
        }
    }
}



// WEBPACK FOOTER //
// ./~/ifdef-loader/ifdef-loader.js??ref--0-1!./~/slotworks/mediators/land-sounds-mediator.ts